module.exports = angular.module('cartographer.map.featurelayer', [])

_ = require 'underscore'
defaultPermissions = require '../plugin/layer/permissions.generated'

module.exports.factory 'crtFeatureLayer', $DI (
  crtLog
  crtConfig
  crtPromise
  crtHttp
  crtLocation
  crtDatetime
  crtAttributeLayer
  crtMapCollaborationModel
  crtMapPermissionModel
) ->
  class crtFeatureLayer
    constructor: (@id, @name, @atlasMapId, @defaultMapEngine, @collaborationModel, @permissionModel, @selectionRadius, @hasTimestamp, @enableHistogram, @enableTimeline, @defaultAttribute, @_attributeGroups, @crossWorkspace) ->
      @defaultMapEngine ?= "angular"
      @hasTimestamp     ?= true
      @enableHistogram  ?= true
      @enableTimeline   ?= true
      @crossWorkspace   ?= false

    # -> arrayOf(crtAttributeGroup)
    attributeGroups: =>
      @_attributeGroups

    # -> arrayOf(crtAttributeLayer)
    attributes: =>
      _.chain(@_attributeGroups)
       .map((group) => group.attributes())
       .flatten()
       .value()

    # string -> or(crtAttributeLayer, null)
    attribute: (id) =>
      for attr in @attributes() when id == attr.id
        return attr

  class crtAttributeGroup
    constructor: (@id, @name, @_attributes) ->
      # Do nothing

    # -> arrayOf(crtAttributeLayer)
    attributes: =>
      @_attributes

    # string -> or(crtAttributeLayer, null)
    attribute: (id) =>
      for attr in @attributes() when id == attr.id
        return attr

  create = ({
    id
    name
    atlasMapId
    defaultMapEngine
    collaborationModel
    permissionModel
    selectionRadius
    enableHistogram
    enableTimeline
    defaultAttribute
    attributeGroups
    hasTimestamp
  }) ->
    collaborationModel ?= defaultPermissions[id]?.collaborationModel ? throw new Error("No collaboration model found for map layer: #{id}")
    permissionModel    ?= defaultPermissions[id]?.permissionModel    ? throw new Error("No permission model found for map layer: #{id}")
    new crtFeatureLayer(
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius
      hasTimestamp ? true
      enableHistogram ? true
      enableTimeline ? true
      defaultAttribute
      attributeGroups
    )

  # string string -> crtAttributeGroup
  createAttributeGroup = (id, name, attrs) ->
    new crtAttributeGroup(id, name, attrs)

  # Create a simple single-attribute layer involving survey status only.
  createPlaceholder = ({ id, name, atlasMapId, defaultMapEngine, collaborationModel, permissionModel }) ->
    collaborationModel ?= defaultPermissions[id]?.collaborationModel ? throw new Error("No collaboration model found for map layer: #{id}")
    permissionModel    ?= defaultPermissions[id]?.permissionModel    ? throw new Error("No permission model found for map layer: #{id}")
    create({
      id
      name
      atlasMapId
      defaultMapEngine
      collaborationModel
      permissionModel
      selectionRadius: crtConfig.map.selectionRadius
      hasTimestamp: true
      enableHistogram: false
      enableTimeline: false
      attributeGroups: [ createAttributeGroup(id, name, [ crtAttributeLayer.createPlaceholder() ]) ]
    })

  return {
    create
    createAttributeGroup
    createPlaceholder
  }
